module.exports = __webpack_public_path__ + "static/media/print_icon.42b6b0d1.svg";